"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("display:flex;flex-shrink:0;align-items:center;height:", (0, _util.rem)(56), ";background-color:", theme.color.monochrome.white, ";border-bottom:1px solid ", theme.color.monochrome.medium, ";padding:0 ", (0, _util.rem)(24), ";position:sticky;top:0;z-index:999;" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var wrapper = /*#__PURE__*/(0, _react.css)("display:flex;align-items:center;&>*{margin-left:", (0, _util.rem)(16), ";}button:not(:first-of-type){margin-left:", (0, _util.rem)(8), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:wrapper;"));
var BaseTab = process.env.NODE_ENV === "production" ? {
  name: "1tx1l5v",
  styles: "margin-right:auto"
} : {
  name: "h26z7n-BaseTab",
  styles: "margin-right:auto;label:BaseTab;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var bigTab = function bigTab(theme) {
  return /*#__PURE__*/(0, _react.css)(BaseTab, ";align-self:flex-end;margin-left:-", theme.spacing[3], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:bigTab;"));
};

var smallTab = /*#__PURE__*/(0, _react.css)(BaseTab, ";align-self:center;" + (process.env.NODE_ENV === "production" ? "" : ";label:smallTab;"));

var backBtnWrapper = function backBtnWrapper(theme) {
  return /*#__PURE__*/(0, _react.css)("border-right:1px solid ", theme.color.monochrome.medium, ";height:", (0, _util.rem)(40), ";margin-right:", theme.spacing[12], ";display:flex;align-items:center;button{color:", theme.color.monochrome.mediumDark, ";margin:0 ", theme.spacing[10], " 0 -", theme.spacing[5], ";padding:0 ", theme.spacing[5], ";&>span{display:inline-block;position:relative;width:", theme.spacing[8], ";height:", theme.spacing[8], ";transition:all 0.2s;&::before,&::after{position:absolute;display:block;content:'';}&::before{width:", theme.spacing[5], ";height:", theme.spacing[5], ";border-top:2px solid;border-left:2px solid;border-color:currentColor;top:50%;left:2px;transform-origin:0% 0%;transform:rotatez(-45deg);}&::after{width:", theme.spacing[5], ";height:2px;top:50%;background-color:currentColor;transition:width 0.2s,margin 0.2s;transform:translate(5px, -50%);}}&:focus,&:hover{&>span{margin-left:-2px;margin-right:2px;&::after{width:", theme.spacing[7], ";margin-left:-2px;}}}}" + (process.env.NODE_ENV === "production" ? "" : ";label:backBtnWrapper;"));
};

var styles = {
  base: base,
  bigTab: bigTab,
  smallTab: smallTab,
  wrapper: wrapper,
  backBtnWrapper: backBtnWrapper
};
exports.styles = styles;
//# sourceMappingURL=Header.styles.js.map